import script from "./TrainingView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingView.vue?vue&type=script&setup=true&lang=js"

import "./TrainingView.vue?vue&type=style&index=0&id=0c01d465&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_db7f3463623555724ece677ccfae2485/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c01d465"]])

export default __exports__